import { createAsyncThunk } from "@reduxjs/toolkit";
import { multitenantRoutes } from "../../../Constants/api";
import { getRequest } from "../../../Utilities/ApiHelpers/ApiHelpers.index";

export const getExceptions = createAsyncThunk(
  multitenantRoutes.getExceptions,
  async () => {
      const response = await getRequest(multitenantRoutes.getExceptions);
      return response.data;
  }
);
